import React, { useState, useEffect } from "react";
import "../components/Gallery2/MasonaryView.css";
import { useNavigate } from "react-router-dom";
import { Blurhash } from "react-blurhash";
import Button from "../components/Button/Button";
import data from "../config/data.json";

const images = data.masonary_images;

const MasonaryPage = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);

    // Preload images and update state if already cached
    images.forEach((image, index) => {
      const img = new Image();
      img.src = image.src;
      if (img.complete) {
        setLoaded((prev) => ({ ...prev, [index]: true }));
      } else {
        img.onload = () => handleImageLoad(index);
        img.onerror = () => console.error(`Image failed to load: ${image.src}`);
      }
    });
  }, []);

  const handleImageLoad = (index) => {
    setLoaded((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="full-gallery-container">
      <div className="full-gallery-header">
        <h1>Our Gallery</h1>
        <div onClick={() => navigate(-1)}>
          <Button
            text="Back"
            size="discord"
            color="black"
            type="button"
            className="fs-6"
          />
        </div>
      </div>

      <div className="masonry-gallery">
        {images.map((image, index) => (
          <div className="masonry-item" key={index}>
            {loaded[index] ? (
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                className="masonry-image masonry-image-loaded"
              />
            ) : (
              <Blurhash
                hash={image.hash}
                width="100%"
                height="200px"
                resolutionX={32}
                resolutionY={32}
                punch={1}
                className="blurhash-placeholder"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasonaryPage;
